async function fetchCart(){
	try {
		const response = await fetch(window.Shopify.routes.root + 'cart.js');
		if (!response.ok) { throw new Error(`error: ${response.status}`); }
		const data = await response.json();
		cartData = data;
		return data;
	} catch (e){
		console.log(e);
	}
}

function initGiftWrapUpsell(){
	let sideCart = document.getElementById('sidebar-cart');
	if(typeof sideCart == "undefined" ){
		return;
	}

	//remove and previous upsells
	Array.from(document.getElementsByClassName('cart-gift-wrap-upsell')).forEach( el => {
		el.remove();
	});

	fetchCart().then( data => {
		console.log(data)
		data.items.forEach(item => {
			if(giftWrapUpsellArr.some( block => block.productHandle == item.handle )){
				let upsellProduct = giftWrapUpsellArr.find( block => block.productHandle == item.handle);
				if(!data.items.some(cartItem => cartItem.handle == upsellProduct.handle)){
					createGiftWrapUpsell(upsellProduct);
				}
			}
		})
		if(data.items.some( obj => obj.handle == 'power-lunch-ring-set' )){

		}
	})

	setTimeout(()=>{
		Array.from(document.getElementsByClassName('cart-gift-wrap-upsell__btn')).forEach( el => { 
			el.addEventListener('click', e => {
				e.preventDefault();
				console.log(e.target.dataset.vid)
				let formData = {
				'items': [{
					'id': e.target.dataset.vid,
					'quantity': 1
					}]
				};
				fetch(window.Shopify.routes.root + 'cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(formData)
				})
				.then(response => {
					document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));
				})
				.catch((error) => {
					console.error('Error:', error);
				});
			})
		})
		Array.from(document.getElementsByClassName('close-upsell-btn')).forEach( el => { 
			el.addEventListener('click', e => {
				e.target.parentNode.remove();
			})
		})
	}, 1000)

	function createGiftWrapUpsell(p){
		console.log('createGiftWrapUpsell');
		let title = p.title;
		if(p.customTitle != '') {
			title = p.customTitle;
		}
		let html = `
			<button class="close-upsell-btn Icon-Wrapper--clickable">
				<svg class="close" role="presentation" viewBox="0 0 16 14">
					<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
				</svg>
			</button>
			<div class="cart-gift-wrap-upsell__image CartItem__ImageWrapper AspectRatio">
				<div class="AspectRatio" style="--aspect-ratio: 0.8">
					<img class="CartItem__Image" src="${p.image}" alt="${title}">
				</div>
			</div>

			<div class="cart-gift-wrap-upsell__content">
				<p>${title}</p>
				<button class="cart-gift-wrap-upsell__btn Button Button--primary Button--upsellATC" data-vid="${p.variantId}">
					Add - ${p.price} 
				</button>
			</div>	
		`;
		let upsell = document.createElement('div');	
		upsell.classList.add('cart-gift-wrap-upsell');
		upsell.innerHTML = html;
		let cartList = document.getElementById('sidebar-cart').getElementsByClassName('Cart__ItemList')[0];
		cartList.parentNode.insertAdjacentElement('beforebegin', upsell);
	}
}


initGiftWrapUpsell();

(()=>{
// watch cart item list for changes
	let previousCartContent = 0;
	if(document.getElementsByClassName('Cart__ItemList').length){
		previousCartContent = document.getElementsByClassName('Cart__ItemList')[0].innerHTML.length;
	}

	setInterval(() => {
		let currentCartContent = 0;
		if(document.getElementsByClassName('Cart__ItemList').length){
			currentCartContent = document.getElementsByClassName('Cart__ItemList')[0].innerHTML.length;
		}
		if(previousCartContent !== currentCartContent){
			//console.log('change')

			initGiftWrapUpsell();
			previousCartContent = currentCartContent;
		}
	}, 1000)
})()